/* eslint-disable prettier/prettier */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import queryString from "query-string";
import * as Sentry from "@sentry/react";
import { Button as MuiButton, Collapse, IconButton } from "@mui/material";
import { Helmet } from "react-helmet";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import useUserConfig from "../../../hooks/useUserConfig";
import useQueryParams from "../../../hooks/useQueryParams";
import {
  selectAllSIUsers,
  selectOSKeysByUserRole,
} from "../../../redux/selectors/user";
import PersonalDetailsSearch from "../../member/MemberSearch/PersonalDetailsSearch";
import OrganizationSearch from "../../member/MemberSearch/OrganizationSearch";
import {
  AppliedFilterLabelMap,
  Constants,
  DATES,
  EVENT_NAME,
} from "../../../contants";
import { formDataToObject, isEmptyObj } from "../../../utils/helper";
import {
  getAdminRoutePath,
  getFilters,
  handleDependencyFilter,
  performOperation,
} from "../../member/MemberSearch/utils";
import { SET_SELECTED_MEMBER_TRANSFER } from "../../../redux/actionTypes/dashboard";
import { ROUTES } from "../../../utils/constants";
import Styles from "./style";
import AppliedFilter from "../../../components/common/AppliedFilter/AppliedFilter";
import ReloadIcon from "../../../assets/svg/ReloadIcon";
import Loader from "../../../components/common/Loader/Loader";
import MemberRoleTable from "../MemberRoleTable";
import Modal from "../../../components/common/Modal/Modal";
import Pagination from "../../../components/common/new/Pagination/Pagination";
import Member from "../../../services/api/memberSearch";
import MemberRoleModal from "../MemberRoleTable/MemberRoleModal/MemberRoleModal";
import PasswordResetModal from "../MemberRoleTable/PasswordResetModal/PasswordResetModal";
import { getFormattedQuery } from "./utils";
import ImpersonationModal from "../MemberRoleTable/ImpersonationModal/ImpersonationModal";
import BulkTransferSearch from "./components/BulkTransferSearch";
import Toast from "../../../components/common/Toast";

const LOADER_DELAY = 1000;
const PAGE = "page";

const intialPaginationState = {
  currentPage: 0,
  totalPages: 0,
  totalElements: 0,
  pageSize: Constants.DEFAULT_PAGE_SIZE,
};

const filterOrder = [
  "areaId",
  "clusterId",
  "zoneId",
  "regionId",
  "chapterId",
  "districtId",
  "blockId",
];

function RoleManagement() {
  const TITLE = "Role Management - BSG";
  const [searchData, setSearchData] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [paginationInfo, setPaginationInfo] = useState(intialPaginationState);
  const [isLoading, setIsLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openPasswordModal, setOpenPasswordModal] = useState(false);
  const [openImpersonationModal, setOpenImpersonationModal] = useState(false);
  const [openResultModal, setOpenResultModal] = useState(false);
  const allowModalRef = useRef(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [showToast, setShowToast] = useState(null);
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false
  );

  const formRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const metaData = useSelector((state) => state.meta);
  const disabledOSKeys = useSelector(selectOSKeysByUserRole);
  const { isHelpDesk, isHelpDeskAdmin } = useSelector(selectAllSIUsers);
  const hasPermission = useUserConfig();
  const { getQueryObject, getQueryParams, urlSearchParams } = useQueryParams();
  const [isBulkActionOpen, setIsBulkActionOpen] = useState(false);

  useEffect(() => {
    const onResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const updatePaginationInfo = (pagination) => {
    setPaginationInfo({
      currentPage: pagination.number,
      totalPages: pagination.totalPages,
      totalElements: pagination.totalElements,
      pageSize: pagination.size,
    });
  };

  const clearFormRef = () => {
    Object.keys(AppliedFilterLabelMap).forEach((key) => {
      if (formRef.current[key]) {
        formRef.current[key].value = "";
        formRef.current[key]?.blur();
      }
    });
  };
  const getCleanQueryObject = (obj = {}) =>
    Object.fromEntries(
      Object.entries(obj).filter(
        ([, val]) => val !== undefined && String(val).trim() !== ""
      )
    );

  const getComparableFilters = (obj = {}) =>
    Object.fromEntries(
      Object.entries(obj)
        .filter(
          ([key, val]) =>
            !["page", "pageSize"].includes(key) &&
            val !== undefined &&
            String(val).trim() !== ""
        )
        .sort(([a], [b]) => a.localeCompare(b))
    );
  const resetFormState = () => {
    setSearchData([]);
    setAppliedFilters([]);
    setPaginationInfo(intialPaginationState);
    clearFormRef();
  };

  const initializeFormState = (queryObject) => {
    if (!isEmptyObj(queryObject)) {
      clearFormRef();
      Object.keys(queryObject).forEach((key) => {
        if (formRef.current[key]) {
          formRef.current[key].value = queryObject[key];
        }
      });
    }
  };

  const updateSearchParam = (query) => {
    if (query?.length) {
      navigate(`${getAdminRoutePath()}?${query}`);
    } else {
      navigate(`${getAdminRoutePath()}`);
    }
  };

  const removeKeyFromQuery = (queryObject, filterKey) => {
    let updatedQuery = { ...queryObject, page: 0 };

    if (DATES.includes(filterKey)) {
      delete updatedQuery[filterKey];
      delete updatedQuery[`${filterKey.split("From")[0]}To`];
    } else {
      delete updatedQuery[filterKey];
    }

    if (Object.keys(updatedQuery).length === 1 && PAGE in updatedQuery) {
      delete updatedQuery[PAGE];
    }

    if (disabledOSKeys && Array.isArray(disabledOSKeys)) {
      updatedQuery = handleDependencyFilter(updatedQuery, disabledOSKeys);
    }

    return updatedQuery;
  };

  const onRemoveFilter = (filterKey) => {
    setPaginationInfo(intialPaginationState);
    let queryObject = getQueryObject();
    queryObject = removeKeyFromQuery(queryObject, filterKey);
    const updatedQuery = queryString.stringify(queryObject);
    updateSearchParam(updatedQuery);
  };

  const hasAnyRealFilter = (q) => {
    if (!q || isEmptyObj(q)) return false;
    return Object.entries(q).some(
      ([k, v]) =>
        !["page", "pageSize"].includes(k) &&
        v !== undefined &&
        String(v).trim() !== ""
    );
  };

  const fetchSearchData = async (queryParams, params = {}) => {
    try {
      setIsLoading(true);
      const formattedQuery = getFormattedQuery(queryParams);
      const { data } = await Member.adminSearch(formattedQuery, params);

      setTimeout(() => {
        setSearchData(data.content);
        updatePaginationInfo(data);
        setIsLoading(false);

        if (data.content?.length > 0) {
          if (allowModalRef.current) {
            setOpenResultModal(true);
            allowModalRef.current = false;
          }
        } else {
          setShowToast({
            severity: "error",
            message: "No data found",
          });
          setOpenResultModal(false);
          allowModalRef.current = false;
        }
      }, LOADER_DELAY);
    } catch (error) {
      setIsLoading(false);
      setShowToast({
        severity: "error",
        message: error.message || "Something went wrong",
      });
      Sentry.captureException(error);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setPaginationInfo(intialPaginationState);

    const rawFormData = new FormData(formRef.current);
    const formData = getCleanQueryObject(formDataToObject(rawFormData));

    const hasFilter = Object.keys(formData).length > 0;

    if (!hasFilter) {
      setShowToast({
        severity: "warning",
        message: "Please select your search filter",
      });
      return;
    }

    document.dispatchEvent(new Event(EVENT_NAME));
    allowModalRef.current = true;

    const nextFilterOnly = getComparableFilters(formData);
    const currentFilterOnly = getComparableFilters(getQueryObject());

    const isSameSearch =
      queryString.stringify(currentFilterOnly) ===
      queryString.stringify(nextFilterOnly);

    const nextQueryObject = {
      ...formData,
      page: 0,
    };

    if (isSameSearch) {
      const [query, params] = getQueryParams(nextQueryObject);
      fetchSearchData(query, params);
      return;
    }

    const query = queryString.stringify(nextQueryObject);
    updateSearchParam(query);
  };

  useEffect(() => {
    const queryObject = getQueryObject();

    if (isEmptyObj(queryObject)) {
      resetFormState();
      setOpenResultModal(false);
      allowModalRef.current = false;
      return;
    }

    if (!hasAnyRealFilter(queryObject)) {
      resetFormState();
      setOpenResultModal(false);
      allowModalRef.current = false;
      if (
        queryObject.page !== undefined ||
        queryObject.pageSize !== undefined
      ) {
        updateSearchParam();
      }
      return;
    }

    const [query, params] = getQueryParams(queryObject);
    fetchSearchData(query, params);
    initializeFormState(query);
  }, [urlSearchParams.toString()]);

  useEffect(() => {
    const queryObject = getQueryObject();
    if (
      !isEmptyObj(queryObject) &&
      metaData &&
      disabledOSKeys &&
      Array.isArray(disabledOSKeys) &&
      hasAnyRealFilter(queryObject)
    ) {
      const query = getQueryParams(queryObject)[0];
      try {
        setAppliedFilters(getFilters(query, metaData, disabledOSKeys));
      } catch (err) {
        console.error("Error in getFilters:", err);
        setAppliedFilters([]);
      }
    } else {
      setAppliedFilters([]);
    }
  }, [metaData, disabledOSKeys, urlSearchParams.toString()]);

  const onPaginationClick = (clickedNumber) => {
    const queryObject = getQueryObject();
    const queryParams = queryString.stringify({
      ...queryObject,
      page: clickedNumber,
    });
    updateSearchParam(queryParams);
  };

  const onPageSizeClick = (operator) => {
    const queryObject = getQueryObject();
    const queryParams = queryString.stringify({
      ...queryObject,
      page: 0,
      pageSize: queryObject.pageSize
        ? performOperation(
            queryObject.pageSize,
            Constants.DEFAULT_PAGE_SIZE,
            operator
          )
        : 2 * Constants.DEFAULT_PAGE_SIZE,
    });
    updateSearchParam(queryParams);
  };

  const onSelectMemberForTransfer = (member) => {
    dispatch({
      type: SET_SELECTED_MEMBER_TRANSFER,
      payload: member,
    });
    navigate(ROUTES.MEMBER_TRANSFER_REQUEST.path);
  };

  const onEdit = (row) => {
    setSelectedMember(row);
    setOpenModal(true);
  };

  const onResetPassword = (row) => {
    setSelectedMember(row);
    setOpenPasswordModal(true);
  };

  const closeModal = () => {
    setOpenModal(false);
  };

  const closePasswordModal = () => {
    setOpenPasswordModal(false);
  };

  const onImpersonation = (row) => {
    setSelectedMember(row);
    setOpenImpersonationModal(true);
  };

  const closeImpersonationModal = () => {
    setOpenImpersonationModal(false);
  };

  const handleGoBackToSearch = () => {
    setOpenResultModal(false);
    allowModalRef.current = false;
  };

  const handleResetAndClose = () => {
    resetFormState();
    updateSearchParam();
    setOpenResultModal(false);
    allowModalRef.current = false;
  };

  const onRefresh = () => {
    const queryObject = getQueryObject();
    const [query, params] = getQueryParams(queryObject);
    fetchSearchData(query, params);
  };

  const orderedFilters = filterOrder
    .map((filterKey) =>
      appliedFilters.find((filter) => filter.key === filterKey)
    )
    .filter(Boolean);

  const additionalFilters = appliedFilters.filter(
    (filter) => !filterOrder.includes(filter.key)
  );

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>

      <div style={Styles.container}>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "1px",
          }}
        >
          <MuiButton
            onClick={handleResetAndClose}
            variant="outlined"
            color="secondary"
            sx={{
              textTransform: "none",
              height: "20px",
              fontSize: "13px",
              fontWeight: "600",
              marginRight: "10px",
              width: "85px",
              padding: "0px !important",
            }}
          >
            Clear Filters
          </MuiButton>
        </div>

        {/* Search Form */}
        <div style={Styles.filter}>
          <form
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "12px",
              width: "100%",
            }}
            onSubmit={onSubmit}
            ref={formRef}
          >
            {/* 1. Organization Structure */}
            <div>
              <div style={{ fontWeight: "600", marginBottom: "8px" }}>
                Organization Structure
              </div>
              <OrganizationSearch
                formRef={formRef}
                disabledOSKeys={disabledOSKeys}
              />
            </div>

            {/* 2. Personal Details */}
            <div>
              <div style={{ fontWeight: "600", marginBottom: "8px" }}>
                Personal Details
              </div>
              <PersonalDetailsSearch
                formRef={formRef}
                disabledOSKeys={disabledOSKeys}
                isRoleManagement
              />
            </div>

            {/* 3. Search Button */}
            <div
              style={{
                display: "flex",
                justifyContent: isMobile ? "center" : "flex-end",
                paddingTop: isMobile ? "20px" : "10px",
                marginRight: isMobile ? "13px" : "10px",
                paddingBottom: isMobile ? "15px" : "0px",
              }}
            >
              <MuiButton
                type="submit"
                variant="contained"
                color="primary"
                sx={{
                  width: isMobile ? "90%" : "auto",
                }}
              >
                Search
              </MuiButton>
            </div>

            {/* 4. Bulk Action Fields - Collapsible */}
            <div>
              <div
                style={{
                  display: "flex",
                  // justifyContent: "space-between",
                  gap: "8px",
                  alignItems: "center",
                  cursor: "pointer",
                  padding: "8px 0",
                  borderBottom: isBulkActionOpen ? "1px solid #e0e0e0" : "none",
                }}
                onClick={() => setIsBulkActionOpen(!isBulkActionOpen)}
              >
                <div style={{ fontWeight: "600", fontSize: "16px" }}>
                  Bulk Action
                </div>
                <IconButton size="small">
                  {isBulkActionOpen ? <RemoveIcon /> : <AddIcon />}
                </IconButton>
              </div>

              <Collapse in={isBulkActionOpen}>
                <div style={{ paddingTop: "12px" }}>
                  <BulkTransferSearch
                    formRef={formRef}
                    disabledOSKeys={disabledOSKeys}
                    isRoleManagement
                    fetchSearchData={fetchSearchData}
                  />
                </div>
              </Collapse>
            </div>
          </form>
        </div>
        {/* Mobile separator border - visual boundary */}
        {isMobile && (
          <div
            style={{
              borderTop: "2px solid #ffffffff",
              paddingTop: "25px",
              paddingBottom: "100px",
              marginTop: "10px",
            }}
          />
        )}

        {isLoading && <Loader />}

        {/* Search Results Modal */}
        <Modal
          open={openResultModal}
          onClose={handleGoBackToSearch}
          title="Search Results"
          customStyle={{
            marginTop: "30px",
            width: "98%",
            maxWidth: "100%",
            height: "90%",
            maxHeight: "100%",
            overflowY: "auto",
            backgroundColor: "#fff",
            display: "flex",
            flexDirection: "column",
            padding: "10px",
            position: "relative",
          }}
        >
          {isLoading ? (
            <Loader />
          ) : searchData.length > 0 ? (
            <>
              {/* Header Row */}
              <div
                style={{
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: "10px",
                  fontWeight: 600,
                  fontSize: 13,
                  marginBottom: "10px",
                  paddingBottom: "10px",
                  borderBottom: "1px solid #eee",
                }}
              >
                {/* Left: Total + Filters */}
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    minWidth: 260,
                    gap: 10,
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <div style={{ flex: "0 0 auto" }}>
                    Total Members: {paginationInfo.totalElements}
                  </div>
                  {appliedFilters.length > 0 && (
                    <div style={{ flex: 1, minWidth: 200 }}>
                      <div style={Styles.filterWrapper}>
                        <div style={Styles.filterContainer}>
                          {orderedFilters.map((filter) => (
                            <AppliedFilter
                              key={filter.key}
                              filter={filter}
                              onRemove={onRemoveFilter}
                            />
                          ))}
                          {additionalFilters.map((filter) => (
                            <AppliedFilter
                              key={filter.key}
                              filter={filter}
                              onRemove={onRemoveFilter}
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* Right: Reload + Back + Clear */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    flexWrap: "wrap",
                    flex: "0 0 auto",
                  }}
                >
                  <div style={Styles.reload} onClick={onRefresh}>
                    <ReloadIcon />
                  </div>
                  <MuiButton
                    onClick={handleResetAndClose}
                    variant="outlined"
                    color="secondary"
                    sx={{
                      textTransform: "none",
                      height: "32px",
                      fontSize: "13px",
                      padding: "0 14px",
                      minWidth: "100px",
                    }}
                  >
                    Clear Filters
                  </MuiButton>
                  <MuiButton
                    onClick={handleGoBackToSearch}
                    variant="contained"
                    color="primary"
                    sx={{
                      textTransform: "none",
                      height: "32px",
                      fontSize: "13px",
                      padding: "0 14px",
                    }}
                  >
                    Back
                  </MuiButton>
                </div>
              </div>

              {/* Table */}
              <div style={{ flex: 1, overflowX: "auto" }}>
                <MemberRoleTable
                  searchData={searchData}
                  onSelectMemberForTransfer={onSelectMemberForTransfer}
                  onEdit={onEdit}
                  onResetPassword={onResetPassword}
                  hasPermission={hasPermission}
                  showStatusColumn={isHelpDesk || isHelpDeskAdmin}
                  onImpersonation={onImpersonation}
                />
              </div>

              {/* Pagination */}
              {searchData.length > 0 && (
                <div style={{ marginTop: "20px" }}>
                  <Pagination
                    totalPages={paginationInfo.totalPages}
                    totalResults={paginationInfo.totalElements}
                    currentPage={paginationInfo.currentPage}
                    pageSize={paginationInfo.pageSize}
                    onChange={onPaginationClick}
                    onPageSizeClick={onPageSizeClick}
                  />
                </div>
              )}
            </>
          ) : null}
        </Modal>

        {/* Other Modals */}
        <Modal
          open={openModal}
          onClose={closeModal}
          title="Roles"
          customStyle={{ width: "60%", maxHeight: "98%", overflow: "auto" }}
        >
          <MemberRoleModal
            open={openModal}
            selectedMember={selectedMember}
            onClose={closeModal}
            callBack={onRefresh}
          />
        </Modal>

        <Modal
          open={openPasswordModal}
          onClose={closePasswordModal}
          customStyle={{ width: "33%" }}
        >
          <PasswordResetModal
            open={openPasswordModal}
            onClose={closePasswordModal}
            selectedMember={selectedMember}
            callBack={onRefresh}
          />
        </Modal>

        <Modal
          open={openImpersonationModal}
          onClose={closeImpersonationModal}
          customStyle={{ width: "40%", maxHeight: "98%", overflow: "auto" }}
        >
          <ImpersonationModal
            open={openImpersonationModal}
            onClose={closeImpersonationModal}
            selectedMember={selectedMember}
          />
        </Modal>

        <Toast
          open={!!showToast}
          severity={showToast?.severity || ""}
          message={showToast?.message || ""}
          handleClose={() => setShowToast(null)}
        />
      </div>
    </>
  );
}

export default RoleManagement;
